// this file will contains all the reducers for the teacher-classes.module
import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";

import * as fromCoursesReducer from "./courses.reducer";
import * as fromStudentMetricsReducer from "./student-metrics.reducer";
import * as fromCourseMetricsReducers from "./course-metrics.reducer";
import * as fromAssignmentsReducers from "./assignments.reducer";
import * as fromPageReducers from "./page.reducer";
import * as fromStudentAssetReducers from "./student-assets.reducer";
import * as fromStudentActiveSubjectsReducers from "./student-active-subjects.reducer";
import * as fromStudentActiveEditionsReducers from "./student-active-editions.reducer";

// this is the type for our teacher-classes.module
// this creates the structure for our state tree
export interface StudentCoursesState {
    // 1st slice of state:
    courses: fromCoursesReducer.StudentCoursesListState;
    studentMetrics: fromStudentMetricsReducer.StudentMetricsState;
    courseMetrics: fromCourseMetricsReducers.CourseMetricsState;
    assignments: fromAssignmentsReducers.AssignmentsListState;
    page: fromPageReducers.PageState;
    studentAssets: fromStudentAssetReducers.StudentAssetsState;
    activeSubjects: fromStudentActiveSubjectsReducers.StudentActiveSubjectsState;
    activeEditions: fromStudentActiveEditionsReducers.StudentActiveEditionsState;
}

// register the reducers
// a slice of state is managed by a reducer function
// ** Remember a reducer is a pure function
// this can be type check with ActionReducerMap as type StudentCoursesState
export const reducers: ActionReducerMap<StudentCoursesState> = {
    courses: fromCoursesReducer.reducer,
    studentMetrics: fromStudentMetricsReducer.reducer,
    courseMetrics: fromCourseMetricsReducers.reducer,
    assignments: fromAssignmentsReducers.reducer,
    page: fromPageReducers.reducer,
    studentAssets: fromStudentAssetReducers.reducer,
    activeSubjects: fromStudentActiveSubjectsReducers.reducer,
    activeEditions: fromStudentActiveEditionsReducers.reducer,
};

// This const creates the base level of our state object and
// will hold a selector for the entire lazy-loaded module
export const getStudentCoursesModuleState = createFeatureSelector<StudentCoursesState>(
    "studentCoursesModule"
);
